import { render, staticRenderFns } from "./ScreenContents.vue?vue&type=template&id=1f2ef716&"
import script from "./ScreenContents.vue?vue&type=script&lang=ts&"
export * from "./ScreenContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports